import React from 'react';
import { LangContext } from '../../contexts/lang.context';
import { Box } from '@material-ui/core';
import { Progress } from 'semantic-ui-react';
import { Symptoms } from '../../constants';
import 'semantic-ui-css/semantic.min.css';

interface StatisticDegreeProps {
  title: string;
  peopleUnit: string;
  totalNum: number;
  symptomCount: { [symptomKey: string]: number };
}

export const StatisticDegree = (props: StatisticDegreeProps) => {
  const { title, peopleUnit, totalNum, symptomCount } = props;
  const { APP, SYMPTOM } = React.useContext(LangContext).currentLangData;

  const symptomInfos = Object.values(Symptoms).map((symptomValue, index) => {
    const key: keyof typeof SYMPTOM = symptomValue;

    return (
      <SymptomInfo
        key={symptomValue}
        name={SYMPTOM[key]}
        num={symptomCount[symptomValue]}
        totalNum={totalNum}
        peopleUnit={peopleUnit}
      />
    );
  });

  return (
    <Box pb={5}>
      <Box pb={2} fontSize={16} fontWeight={550}>
        {`${title}${APP.colon}${totalNum} ${peopleUnit}`}
      </Box>
      {symptomInfos}
    </Box>
  );
};

interface SymptomInfoProps {
  totalNum: number;
  name: string;
  num: number;
  peopleUnit: string;
}

const SymptomInfo = (props: SymptomInfoProps) => {
  const { totalNum, name, num, peopleUnit } = props;
  const { APP } = React.useContext(LangContext).currentLangData;

  type ProgressColor = 'red' | 'orange' | 'yellow' | 'olive';
  const colors: ProgressColor[] = ['olive', 'yellow', 'orange', 'red'];
  const colorIndex: number = Math.floor((num / (totalNum + 1)) * colors.length);
  const color: ProgressColor = colors[colorIndex];

  return (
    <Box>
      <Box fontSize={14}>{`${name}${APP.colon}${num} ${peopleUnit}`}</Box>
      {/* <Progress value={num} total={totalNum} progress="ratio" color={color} /> */}
      <Progress
        percent={Math.round((num / totalNum) * 100)}
        color={color}
        progress
        active
        style={{
          marginBottom: '10px',
        }}
      />
    </Box>
  );
};
